import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import List from "app/stores/list"
import { message } from "antd"

export default class Store {
  @observable detailData = observable.map({})
 
  @observable submitData = {
    name: "",
    type: "",
    orgId: "",
    appType: "",
    appGroupName: "",
    format: "",
    recordState: 0,
    template: "",
    userId:""
  }

  @action createOrg = () => {
    return request.post(`${config.backend}/accounts/template`)
      .send(this.submitData)
      .checkToken()
      .commonDispose()
  }

  @action updateOrg = () => {
    return request.put(`${config.backend}/accounts/template/${this.detailData.get('id')}`)
      .send(this.detailData.toJS())
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData.clear()
          this.list.getTableData()
            .then(
              res => {
                this.list.updateTableData(res)
                this.list.initPageIndex()
              }
            )
          return Promise.resolve(res)
        },
        err => {
          message.error(err.message)
          return Promise.reject(err.message)
        }
      )
  }

  @action getOrgDetail = (id) => {
    return request.get(`${config.backend}/accounts/template/detail/${id}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = observable.map({ ...res })
        }
      )
  }

  @action updateField = (e, field) => {
    this.submitData[field] = e.target.value
  }

  @action setDetailData = (data) => {
    this.detailData.merge(data)
  }
  @action toggleSwitch = (record) => {
    if (record.disable) {
      // this.enable(record)
    } else {
      // this.disable(record)
    }
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "accounts/template")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/preview/template.js